import { render, staticRenderFns } from "./DebtL_Search.vue?vue&type=template&id=645d06a2"
import script from "./DebtL_Search.vue?vue&type=script&lang=js"
export * from "./DebtL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports